<template>
  <div class="modal-content-virtual-member">
    <div class="modal-header">
      <h2>Izmena stana</h2>
    </div>
    <div class="body">
      <div id="first-section">
        <label class="col-form-label col-form-label-lg">
          Prezime i ime
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite prezime i ime"
          v-model.trim="property.contact_full_name"
          @focus="errorOccurred = false"
        />
        <div class="apartment-split">
          <div class="apartment-split-item">
            <label class="col-form-label col-form-label-lg tooltip-label">
              Broj stana
              <span class="mandatory">*</span>
            </label>
            <div class="desc-wrapper">
              <input
                class="form-control"
                rows="4"
                placeholder="Unesite broj stana"
                v-model.trim="property.description"
                @focus="errorOccurred = false"
              />
            </div>
          </div>
          <div class="apartment-split-item">
            <label class="col-form-label col-form-label-lg"
              >Površina (m²) <span class="mandatory">*</span>
            </label>

            <input
              class="form-control"
              rows="4"
              placeholder="Unesite površinu"
              @focus="errorOccurred = false"
              v-model.lazy="property.area_size"
              type="number"
            />
          </div>
        </div>
        <div class="apartment-split">
          <div class="apartment-split-item">
            <label class="col-form-label col-form-label-lg tooltip-label">
              Sprat
              <div class="custom-tooltip">
                <i class="fas fa-info-circle"></i>
                <span class="tooltiptext">
                  Osim brojeva dozvoljene vrednosti su: <br />SU, PR, NPR, VPR,
                  PTK</span
                >
              </div>
            </label>
            <div class="desc-wrapper">
              <input
                class="form-control"
                rows="4"
                placeholder="Unesite broj stana"
                v-model.trim="property.floor"
                @focus="errorOccurred = false"
              />
            </div>
          </div>
          <div class="apartment-split-item">
            <label class="col-form-label col-form-label-lg"
              >Br. članova domaćinstva
            </label>

            <input
              class="form-control"
              rows="4"
              placeholder="Unesite površinu"
              @focus="errorOccurred = false"
              v-model.lazy="property.num_of_members"
              type="number"
            />
          </div>
        </div>
        <label class="col-form-label col-form-label-lg">
          Napomena
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite dodatni opis stana npr. 'advokatska kancelarija'"
          v-model.trim="property.note"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg label-phone-number">
          Broj telefona
        </label>
        <p class="phone-number-explainer">
          Ukoliko unosite više brojeva telefona, razdvojite ih tačka zarezom
          npr. *381 64 654 44 44;+381 63 43 33 554
        </p>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite broj telefona"
          v-model.trim="property.contact_phone"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg">Email</label>
        <p class="phone-number-explainer">
          Ukoliko unosite više email adresa, razdvojite ih tačka zarezom npr.
          ana@gmail.com;milica@gmail.com
        </p>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite email"
          v-model.trim="property.contact_email"
          @focus="errorOccurred = false"
        />
      </div>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          :disabled="loading"
          @click="editProperty"
        >
          <p v-if="!loading">Izmeni stan</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import axios from '@/axios/axios.js';
import { utilService } from '@/util/UtilService.js';

export default {
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      loading: false,
      property: {}
    };
  },
  created() {
    Object.assign(this.property, this.$store.state.modal.property);
    this.property.area_size = Number(this.property.area_size);
  },
  methods: {
    ...mapMutations('modal', ['closeModal', 'removeProperty', 'setProperty']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('table', ['getAllMembersForCommunityFinances']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations('finances', ['setVirtualMembersList']),
    async editProperty() {
      this.errorOccurred = false;
      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }
      this.loading = true;
      try {
        this.property.member_id = this.$store.getters.getActiveCommunity.member_id;
        this.property.numOfMembers = this.property.num_of_members;
        await axios.put(`property/${this.property.id}`, this.property);
        const res = await axios.get(
          `community/${this.$store.getters.getActiveCommunity.id}/properties`
        );
        let tableData = res.data.data;
        this.communityProperties = tableData;
        this.loading = false;
        this.setTableData(this.communityProperties);
        this.removeProperty();
        this.setProperty(this.property);
        this.closeModal();
        this.showSuccessModal();
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.showFailModal();
      }
    },
    validateInput() {
      if (this.property.contact_full_name == '') {
        this.errorMessage = 'Morate uneti prezime i ime';
        return false;
      }
      if (this.property.description.trim() == '') {
        this.errorMessage = 'Morate opis posebnog dela';
        return false;
      }

      if (
        this.property.contact_email &&
        this.property.contact_email != '' &&
        !utilService.isEmailValid(this.property.contact_email)
      ) {
        this.errorMessage = 'Morate uneti ispravnu email adresu';
        return false;
      }
      if (
        this.property.contact_email &&
        this.property.contact_email != '' &&
        this.property.contact_email.length > 250
      ) {
        this.errorMessage = 'Email adresa ne može imati preko 250 karaktera';
        return false;
      }
      if (
        this.property.area_size == null ||
        !this.property.area_size ||
        isNaN(this.property.area_size)
      ) {
        this.errorMessage = 'Morate uneti površinu';
        return false;
      }

      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.tooltiptext {
  width: 150px !important;
  margin-left: -75px !important;
}
</style>
<style lang="scss">
.user--mod {
  .text {
    max-width: calc(100% - 30px) !important;
  }
}
.modal-content-virtual-member {
  .apartment-split {
    width: 100%;
    display: flex;
    .apartment-split-item {
      width: 100%;
    }
    .apartment-split-item:first-child {
      margin-right: 4px;
    }
    .apartment-split-item:last-child {
      margin-left: 4px;
    }
  }
  .input-wrapper {
    display: flex;
    width: 100%;
    position: relative;
    .user--mod {
      width: 100%;
      z-index: 5;
      margin-bottom: 2rem;
      input {
        margin-bottom: 0;
      }
      .ui.fluid.search {
        width: 100%;
        line-height: 1.5;
        border-radius: 0.3rem;
        border: 1px solid #ced4da;
        font-size: 1rem;
        color: inherit;
        transition: 0.2s all;
        height: calc(2.25rem + 2px);

        input {
          border: none;
          padding: 0.5rem 1rem;
          font-size: 1rem;
          line-height: 1;
          max-width: 100%;
        }

        input:focus {
          border: none;
          outline: none;
          & {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .text {
          position: absolute;
          top: 7px;
          left: 1rem;
          color: inherit;
          font-size: 1rem;
        }
        .menu {
          border: 1px solid #ced4da;
          border-radius: 0.3rem;
          border-top-width: 0;
          border-top-right-radius: 0;
          border-top-left-radius: 0;
          z-index: 11;
          background-color: white;
          max-height: 10rem;
          overflow-y: auto;
          margin: -5px -1px 0px -1px;
          .item {
            z-index: 15;
          }
          .item:hover {
            background-color: rgba(0, 0, 0, 0.05);
            cursor: pointer;
          }

          .item.selected {
            background-color: rgba(0, 0, 0, 0.178);
          }

          .btn--add {
            width: 100%;
          }
        }
      }
    }
    .add-member-dropdown {
      .menu {
        max-height: 10rem !important;
      }
    }

    .amount--mod {
      width: 100%;
      margin-bottom: 2rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .relative {
      position: relative;
    }
  }

  .body {
    height: 100%;
    width: 100%;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  .btn-add-desc {
    i {
      margin-left: 4px;
    }
  }

  .desc-wrapper {
    display: flex;
    justify-content: space-between;
    span {
      margin-bottom: 9px;
      margin-left: 8px;
      min-width: 60px;
    }
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .mandatory {
    color: red;
  }

  label.tooltip-label {
    display: flex;
    .mandatory {
      margin-left: 4px;
    }
    .popover {
      position: relative;
      width: fit-content;
      border: none;
      padding: 4px 4px 2px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 1.1rem;
        color: var(--primary-color);
      }
    }
  }
}
</style>
